module.exports = __webpack_public_path__ + "static/media/SeaBg.5c9e6d4b.svg";